<div class="container-fluid">
  <form [formGroup]="myDesignForm">
    <div class="row paddingContainer instDatosDiseno">
      <div class="col-md-6">
        <div class="inputBlock select-container instAlcanceProyecto">
          <mat-label>{{ "centro.centroData.reach" | translate }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="alcancePryID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option *ngFor="let item of tipoAlcanceList" [value]="item.id">
              {{ "centro.reachTypes." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
        <div class="inputBlock instKmRedAbas">
          <mat-label>{{ "centro.centroData.kmRedAbas" | translate }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.kmRedAbas"
            class="dataInput"
            formControlName="kmRedAbas"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
        <div class="inputBlock instKmRedSanea">
          <mat-label>{{
            "centro.centroData.kmRedSanea" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.kmRedSanea"
            class="dataInput"
            formControlName="kmRedSanea"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            twoDecimalNumber
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="inputBlock instCaudalDiseno">
          <mat-label>{{
            "centro.centroData.designFlow" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.caudalDiseno"
            class="dataInput"
            formControlName="caudalDiseno"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
        <div class="inputBlock instNumAbonados">
          <mat-label>{{
            "centro.centroData.subscribers" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.numeroAbonados"
            class="dataInput"
            formControlName="numeroAbonados"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
        <div class="inputBlock instHabitantesEquivalentes">
          <mat-label>{{
            "centro.centroData.habitantesEq" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.habitantesEquivalentes"
            class="dataInput"
            formControlName="habitantesEquivalentes"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
      </div>
    </div>
  </form>
</div>
